<template>
  <div class="answer-form">
    <div class="form mw-64">
      <div class="form__fields mx-1">
        <div class="button-wrapper">
          <button
            class="button button-icon button-icon-full"
            v-on:click="closeForm"
          ><i class="icon icon__back"></i></button>
        </div>

        <h1>
          Бланк ответов
          <br>
          <span class="highlight">
            {{ questionInfo.roundNumber }} раунд
          </span>
        </h1>

        <div class="answer-box__wrapper">
          <answer-box
            v-for="(qi, idx) in questionInfo.questionCount"
            v-bind:questionNumber="qi"
            v-bind:active="qi === questionInfo.questionNumber"
            v-bind:key="idx"
            v-bind:hasFunny="form.xx[qi]"
            v-on:toggleFunny="toggleXXAnswer(qi)"
            v-bind:showBet="isBetRound"
            v-bind:hasBet="form.bet[qi]"
            v-on:toggleBet="toggleBetAnswer(qi)"
            v-model="form.answers[qi]"
          />
        </div>

        <div class="info-block">
          <div class="info-block__text">
            Полезный совет:<br>
            Не оставляйте поля пустыми.<br>
            Придумайте смешной ответ! А вдруг?!
          </div>

          <div class="info-block__timer">
            <sektor-timer />
          </div>
        </div>
      </div>

      <div class="form__controls mx-1">
        <span
          v-if="isLoading"
          class="ajax-loading light"
        ></span>

        <button
          class="button"
          v-on:click="sendForm"
          v-else
        >Отправить {{ questionInfo.roundNumber }} раунд</button>
      </div>
    </div>

    <form
      class="form"
      action=""
      v-if="isQuestion && false"
      v-on:submit.prevent="sendForm"
    >
      <div
        class="input-field"
        v-bind:class="{ current: qi === questionInfo.questionNumber }"
        v-for="(qi, idx) in questionInfo.questionCount"
        v-bind:key="idx"
      >
        <input
          type="text"
          class="form-input"
          v-bind:placeholder="`Ответ на вопрос ${qi}`"
          v-model="form.answers[qi]"
        />

        <div class="answer-mods">
          <button
            class="xx-answer"
            type="button"
            v-bind:class="{ active: form.xx[qi] }"
            v-on:click="toggleXXAnswer(qi)"
          >ROFL</button>

          <button
            v-show="isBetRound"
            class="bet-answer"
            type="button"
            v-bind:class="{ active: form.bet[qi] }"
            v-on:click="toggleBetAnswer(qi)"
          >BET</button>
        </div>
      </div>

      <div class="form-control">
        <span class="form-sent" v-bind:class="{ visible: sentAnswers }">
          отправлено!
        </span>

        <button
          type="button"
          class="button empty close-form-button"
          v-bind:disabled="isLoading"
          v-on:click="closeForm"
        >Закрыть</button>

        <button
          class="button dark"
          v-show="!sentAnswers"
          v-bind:disabled="isLoading"
        >Отправить</button>
      </div>
    </form>

    <button
      class="button transparent button-icon-large close-answer-form"
      v-on:click="closeForm"
      v-bind:disabled="isLoading"
    >
      <i class="icon icon__close icon-large"></i>
    </button>
  </div>
</template>

<script>
import Vue from 'vue';
import FrameModel from '../lib/FrameModel';
import Storage from '../lib/Storage';

import AnswerBox from './shared/AnswerBox.vue';
import { SektorTimer } from './shared/Sektor';

export default {
  name: 'AnswerForm',

  components: {
    AnswerBox,
    SektorTimer,
  },

  props: {
    frame: {
      type: FrameModel,
      required: true,
    },

    isLoading: {
      type: Boolean,
      default: false,
    },

    sentAnswers: {
      type: Boolean,
      default: false,
    },

    gameId: {
      type: String,
    },
  },

  data() {
    return {
      form: {
        answers: {},
        xx: {},
        bet: {},
      },
    };
  },

  mounted() {
    console.log('[AnswerForm] mounted');

    if (this.questionInfo && this.questionInfo.questionCount) {
      for (let i = 0, len = this.questionInfo.questionCount; i < len; i += 1) {
        Vue.set(this.form.xx, i, false);
        Vue.set(this.form.bet, i, false);
      }
    }

    // if there are answers for current round
    this.restoreAnswers();
  },

  computed: {
    isBetRound() {
      // TODO remove after api-update
      if (this.frame.roundType) {
        return this.frame.roundType === 'rt_take_a_chance';
      }

      return this.frame.isBetRound;
    },

    isQuestion() {
      return this.frame.rawType === 'ft_question' || this.frame.rawType === 'ft_cutscene';
    },

    questionInfo() {
      return this.frame.questionInfo;
    },
  },

  methods: {
    closeForm() {
      this.saveAnswers();

      this.$emit('close');
    },

    sendForm() {
      const { answers, xx, bet } = this.form;
      const { roundNumber } = this.questionInfo;

      this.saveAnswers();

      this.$emit('sendAnswers', {
        answers,
        xx,
        bet,
        roundNumber,
      });
    },

    getAnswerObj() {
      const { answers, xx, bet } = this.form;
      return Object.keys(answers)
        .filter(answerKey => !!answers[answerKey])
        .reduce((result, answerKey) => {
          // eslint-disable-next-line no-param-reassign
          result[answerKey] = {
            answer: answers[answerKey],
            xx: !!xx[answerKey],
            bet: !!bet[answerKey],
          };
          return result;
        }, {});
    },

    restoreAnswers() {
      const { roundNumber } = this.questionInfo;
      const key = `${this.gameId}__${roundNumber}`;

      const answerRaw = Storage.get(key) || {};
      let answerObj = {};

      try {
        answerObj = JSON.parse(answerRaw);
      } catch {
        // pass
      }

      Object.keys(answerObj)
        .forEach((answerKey) => {
          // console.log(
          //   'Question #%s -> %s, bet %s , xx %s',
          //   answerKey,
          //   answerObj[answerKey].answer,
          //   answerObj[answerKey].bet,
          //   answerObj[answerKey].xx,
          // );

          Vue.set(this.form.answers, answerKey, answerObj[answerKey].answer);
          Vue.set(this.form.xx, answerKey, answerObj[answerKey].xx);
          Vue.set(this.form.bet, answerKey, answerObj[answerKey].bet);
        });
    },

    saveAnswers() {
      const { roundNumber } = this.questionInfo;
      const key = `${this.gameId}__${roundNumber}`;
      Storage.set(key, JSON.stringify(this.getAnswerObj()));
    },

    toggleXXAnswer(qi) {
      Vue.set(this.form.xx, qi, !this.form.xx[qi]);
    },

    toggleBetAnswer(qi) {
      Vue.set(this.form.bet, qi, !this.form.bet[qi]);
    },
  },
};
</script>
